import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export class SpinnerWithList {
  constructor() {
    this.SpinnerWithList()
  }

  SpinnerWithList() {
    const animationItems = document.querySelectorAll('.spinner-with-list__animation') as NodeListOf<HTMLElement>

    gsap.from(animationItems, {
      scrollTrigger: {
        trigger: '.spinner-with-list',
        toggleClass: 'active',
      },
    })
  }
}
